export default class KFontWeights {
  static bold = 700;
  static medium = 500;
  static regular = 400;
}
